var _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderMenuIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 6.5,
    x2: 28,
    y2: 6.5,
    stroke: "#585858"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14.5,
    x2: 28,
    y2: 14.5,
    stroke: "#585858"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 22.5,
    x2: 28,
    y2: 22.5,
    stroke: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMenuIconGray);
export default __webpack_public_path__ + "static/media/headerMenuIconGray.e8b2caa7d883fef29f72894a86a67a40.svg";
export { ForwardRef as ReactComponent };